import gql from 'graphql-tag';

export const GET_BILLS = gql`
    query Bills($offset: Int, $limit: Int, $filters: BillFilters) {
        bills(offset: $offset, limit: $limit, filters: $filters) {
            id
            total
            dicountedTotalValue
            roundedPrice
            totalPriceCurrency{
                currencyCode
            }
            fiscalRecord {
                id
                state
            }
            place {
                id
                name
            }
            issuedBy {
                id
                account {
                    id
                    firstName
                    lastName
                    imageUrl
                }
            }
            issuedUtc
            billState
            billNumber
            paymentMethod
            customPaymentMethod {
                name
            }
        }
    }
`;

export const GET_BILL = gql`
    query Bill($id: String!) {
        bill(id: $id) {
            id
            order {
                id
                name
                orderNumber
                place {
                    id
                    name
                }
            }
            orderLines {
                id
                price
                discountedPrice
                discountedUnitPrice
                priceCurrency {
                    currencyCode
                }
                quantity
                unitPrice
                tax {
                    id
                    rate
                }
                product {
                    id
                    name
                    tax {
                        id
                        rate
                    }
                }
            }
            total
            dicountedTotalValue
            roundedPrice
            totalPriceCurrency {
                currencyCode
            }
            place {
                id
                name
            }
            issuedBy {
                id
                account {
                    id
                    firstName
                    lastName
                    imageUrl
                }
            }
            issuedUtc
            billState
            billNumber
            paymentMethod
            customPaymentMethod {
                name
            }
        }
    }
`;

const sectionOptionFragment = gql`
fragment SectionsOptionFragment on Section {
    name,
    id,
    places {
        id
        name
    }
}
`;

const employeeOptionFragment = gql`
fragment EmployeeOptionFragment on Employee {
    id,
    account {
        id
        firstName
        lastName
    }
}
`;


export const GET_FILTERS_OPTIONS = gql`
    query GetBillFiltersOptions{
        sections {
            ...SectionsOptionFragment
        }
        employees {
            ...EmployeeOptionFragment
        }
    }
    ${sectionOptionFragment}
    ${employeeOptionFragment}
`;
